require('isotope-layout/dist/isotope.pkgd');

var InfiniteScroll = require('infinite-scroll');
var imagesLoaded = require('imagesloaded');


export default {
  init() {
    InfiniteScroll.imagesLoaded = imagesLoaded;

    $('<div>').addClass('grid_spacer').prependTo('.news_posts');
    $('<div>').addClass('grid_sizer').prependTo('.news_posts');

    var $grid = $('.news_posts');
    
    $grid.imagesLoaded( function() {
      $grid.isotope({
        layoutMode: 'masonry',
        percentPosition: true,
        masonry: {
          columnWidth: '.grid_sizer',
          gutter: '.grid_spacer',
          horizontalOrder: true,
        },
        itemSelector : 'article',
      });
    });    

    var $container = $('.news_posts');
    
    var $infinite_scroll = $container.infiniteScroll({
      path: '.nav-previous a',
      append: 'article.post',
      history: false,
      hideNav: '.nav-links',
      checkLastPage: true,
    });

    $infinite_scroll.on( 'append.infiniteScroll', function( event, response, path, elements ) {
      var $newElems = $( elements ).hide();
      $newElems.imagesLoaded(function(){
          $newElems.show();
          $grid.isotope( 'appended', $newElems );
      });
    });

    $('body:not(.category) #menu-news-navigation li a').on( 'click', function( event ) {
      click_filter(event, $(this), 1);
    });

    function click_filter(event, ele, record_event_in_pushstate) {
      event.preventDefault();
    
      $('#menu-news-navigation .menu-item').removeClass('active');
      if ( ele.text() == 'All' ) {
          $container.isotope({ filter: '*' });
          if (record_event_in_pushstate == 1) {
            history.pushState('menu-all', 'Book Works - News', '/news/');
          }
          ele.parent('li').addClass('active');
      } else {
    
        var targetLink_init = ele[0].href; 
        targetLink_init = targetLink_init.substr(0, targetLink_init.length - 1);
        var targetLink = '.category-' + targetLink_init.substr(targetLink_init.lastIndexOf('/') + 1);
        var target_click_state =  ele.parent('li').attr('class').replace( 'menu-item ', '');// '.menu-' + targetLink_init.substr(targetLink_init.lastIndexOf('/') + 1);
          target_click_state = target_click_state.replace('all-items', '');
          target_click_state = target_click_state.replace('active', '');
        if (record_event_in_pushstate == 1) {
          history.pushState(target_click_state, ele.text(), ele[0].href);   
        }
        $container.isotope({ filter: targetLink });
        ele.parent('li').addClass('active');
      }
    }
    

    window.onpopstate = function(e) {
      e.preventDefault();
      var class_name_ele = '.'+e.state;
      var ele = $(class_name_ele).children('a');
      click_filter(event, ele, 0);
    };


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/blog.js